<div class="container noselect"
     [class.selected]="selected"
     [class.available]="status === getContactStatuses().AVAILABLE"
     [class.away]="status === getContactStatuses().AWAY"
     [class.offline]="status === getContactStatuses().OFFLINE"
     (click)="onSelected.emit(uid)">
  <mat-icon>{{icon}}</mat-icon>
  {{name}}
</div>
